import { useEffect, useState } from 'react';
import { Bars } from 'react-loader-spinner';
import { useJurisdictions } from '../../../../../hooks/useJurisdictions';
import { ToggleWithLabel } from '../ToggleWithLabel';
import { useTranslation } from 'react-i18next';
import { errorToast } from '../../../../../utils/toasts';

interface JurisdictionConfig {
  id: number;
  description: string;
  active: boolean;
}

const JuridictionsTab = () => {
  const { jurisdictions, loading, updateJurisdiction } = useJurisdictions();
  const [jurisdictionStates, setJurisdictionStates] = useState<JurisdictionConfig[]>([]);
  const { t } = useTranslation()
  useEffect(() => {
    if (jurisdictions.length > 0) {
      const initialState = jurisdictions.map((j) => ({
        id: j.jurisdiction_id,
        description: j.jurisdiction_description,
        active: j.is_active === 1
      }));
      setJurisdictionStates(initialState);
    }
  }, [jurisdictions]);

  // const toggleJurisdiction = (id: number) => {
  //   setJurisdictionStates((prev) =>
  //     prev.map((j) => {
  //       if (j.id === id) {
  //         const newActive = !j.active;
  //         updateJurisdiction({
  //           jurisdiction_id: id,
  //           value: 0,
  //           is_active: newActive ? 1 : 0
  //         });
  //         return { ...j, active: newActive };
  //       }
  //       return j;
  //     })
  //   );
  // };

  const toggleJurisdiction = async (id: number) => {
    setJurisdictionStates((prev) =>
      prev.map((j) =>
        j.id === id ? { ...j, active: !j.active } : j
      )
    );
  
    const changed = jurisdictionStates.find((j) => j.id === id);
    if (!changed) return;
  
    try {
      await updateJurisdiction({
        jurisdiction_id: id,
        value: 0,
        is_active: changed.active ? 0 : 1
      });
    } catch (error) {
      console.error('Erro ao atualizar jurisdição', error);
      errorToast(t('environment.errorUpdatingJurisdiction'));
    }
  };

  if (loading)
    return (
      <div className="flex items-center justify-center py-6">
        <Bars height="32" width="32" color="#4B5563" />
      </div>
    );

  return (
    <div className="flex flex-col gap-4">
      <h2 className="text-lg font-medium mt-4">{t('config.TabJurisdictions')}</h2>

      {jurisdictionStates.map((j) => (
        <div
          key={j.id}
          className="border border-dashed p-4 rounded flex items-center justify-between"
        >
          <span className="text-sm">{j.description}</span>
          <ToggleWithLabel
            checked={j.active}
            onChange={() => toggleJurisdiction(j.id)}
          />
        </div>
      ))}
    </div>
  );
};

export { JuridictionsTab };
